import { render, staticRenderFns } from "./Game5-6.vue?vue&type=template&id=6984c7fb&scoped=true&"
import script from "./Game5-6.vue?vue&type=script&lang=js&"
export * from "./Game5-6.vue?vue&type=script&lang=js&"
import style0 from "./Game5-6.vue?vue&type=style&index=0&id=6984c7fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6984c7fb",
  null
  
)

export default component.exports